import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Select from './Select';
import { CheckboxOption } from './components/input-options';

const CheckboxSelect = ({
  components,
  ...props
}) => {
  const temp = { ...components,
    Option: CheckboxOption
  };
  return /*#__PURE__*/React.createElement(Select, _extends({
    closeMenuOnSelect: false,
    hideSelectedOptions: false,
    isMulti: true,
    components: temp
  }, props));
};

export default CheckboxSelect;